/**
 * A panel from the mock that has no source in this system yet.
 *
 * It renders the frame and states the reason, rather than being hidden or
 * filled with the mock's invented content (Matthew, 4 September 2026).
 * Hiding it would make the gap invisible and the layout lie about what
 * the surface covers; filling it would be worse, because an invented
 * number on a dashboard gets quoted.
 *
 * The reason is a business fact, not a UI string: it belongs beside the
 * panel that needs it and changes when the source arrives.
 */
export function EmptyPanel({ title, reason }: { title: string; reason: string }) {
  return (
    <section className="cc-empty-panel" aria-label={title}>
      <h3>{title}</h3>
      <p>{reason}</p>
    </section>
  );
}
